<template functional>
  <div
    v-if="props.value"
    class="dataset-cell-tag-status tag"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
    :style="{
      backgroundColor: props.value.ColorBackground,
      color: props.value.ColorText
    }"
  >
    <b-tooltip
      :active="$options.title(props)[0] !== null"
      :label="$options.title(props)[0]"
      :type="$options.title(props)[1]"
    >
      {{ props.value.Name }}
    </b-tooltip>
  </div>
</template>

<script>
import ModuleBase from './module-base'
import { DateTime } from 'luxon'
import store from '@/store'

export default {
  name: 'DatasetCellTagStatus',
  mixins: [ModuleBase],
  title: props => {
    // only use if provide settle date / clear date
    if (!props.row.SettleDate && !props.row.ClearDate) return [null, null]

    const tz = store.state.user.me.Timezone
    const date = DateTime.fromISO(props.row.ClearDate)

    const datestring = date.invalid
      ? 'Date is incorrect. Please contract admin for support.' 
      : date.setZone(tz).toLocaleString(DateTime.DATE_SHORT)

    switch (props.row.StatusValue || props.row.Status.Value) {
      case 'Transactions_bounced':
      case 'Transactions_finished':
      case 'Transactions_blocked':
        return [datestring, date.invalid ? 'is-warning' : 'is-primary']
        
      default:
        return [null, 'is-black']
    }
  },
}
</script>
